export default __webpack_public_path__ + "static/media/IMG_1368.9fb00d6a.jpg";